const atualizarGrupoEquipamentos = (state, grupoEquipamentos) => {
    state.grupoEquipamentos = grupoEquipamentos;
}

const atualizarGrupoEquipamento = (state, grupoEquipamento) => {
    state.grupoEquipamento = grupoEquipamento;
}

export default {
    atualizarGrupoEquipamentos,
    atualizarGrupoEquipamento
}